export const YEAR_IN_REVIEW = {
  LABEL: 'Year in Review',
  MOCK_VIDEO_URL:
    'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
};
